export const INSPECTOR_PORTAL_TIMELINE_MAX_ITEMS = 5;
